import Joi from 'joi';

export const ActivitySchema = Joi.object({
  name: Joi.string().required(),
  startDate: Joi.date().required(),
  endDate: Joi.date().min(Joi.ref('startDate')).required(),
  provinces: Joi.array().items(Joi.string()).min(1).required(),
  hasMessage: Joi.boolean().required(),
});

export const ActivityMessageSchema = Joi.object({
  activityId: Joi.number().required(),
  userIds: Joi.array().items(Joi.string()).min(1).required(),
  content: Joi.string().required(),
});
